import { makeStyles } from '@material-ui/core'
import { KeyboardArrowRight, KeyboardArrowDown } from '@material-ui/icons'
import clsx from 'clsx'
import React from 'react'

type AccordionIconProps = {
  isOpened: boolean
  className?: string
}

const AccordionIcon = ({ isOpened, className }: AccordionIconProps) => {
  const classes = useStyles()

  return (
    <div className={clsx(classes.iconContainer, className)}>
      {isOpened ? <KeyboardArrowDown /> : <KeyboardArrowRight />}
    </div>
  )
}

export default AccordionIcon

const useStyles = makeStyles({
  iconContainer: {
    display: 'flex',
    '&:hover': {
      cursor: 'pointer',
    },
  },
})
